import { useState } from 'react'
import styled from 'styled-components'
import { Row } from 'styled/alignment/Row'
import colors from 'theme/colors'
import { panelAccent, panelAccentAlpha } from 'theme/panelAccent'

export default function Tabs({ tabs, containerStyle, onChangeTab }) {
    const [selectedTab, setSelectedTab] = useState(tabs[0].name)

    function changeTab(tab) {
        setSelectedTab(tab)
        onChangeTab(tab)
    }

    return (
        <ContainerTab style={containerStyle}>
            <StyledTab role='tablist'>
                {Object.values(tabs).map((tab) => {
                    const Icon = tab.icon;

                    return (
                        <TabItem
                            key={tab.name}
                            type='button'
                            role='tab'
                            aria-selected={selectedTab === tab.name}
                            onClick={() => changeTab(tab.name)}
                            active={selectedTab === tab.name}
                            disabled={tab.disabled}
                        >
                            {Icon && <Icon size={15} />}
                            {tab.label}
                        </TabItem>
                    );
                })}
            </StyledTab>
        </ContainerTab>
    );
}

const ContainerTab = styled.div`
    display: flex;
    justify-content: flex-start;
`

const StyledTab = styled(Row)`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 2px;
    background: ${colors.neutralLight};
    border: 1px solid ${colors.neutralDark};
    border-radius: 10px;
    padding: 4px;
    overflow-x: auto;

    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
`;

const TabItem = styled.button`
    cursor: pointer;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    border: none;
    border-radius: 8px;
    width: auto;
    padding: 0 16px;
    text-align: center;
    background: transparent;
    color: ${colors.night};
    font-weight: 400;
    font-size: 14px;
    font-family: inherit;
    white-space: nowrap;
    transition: all ease-in-out 0.2s;

    &:hover {
        ${({ disabled, active }) => !disabled && !active && `
            background: ${colors.neutral};
            color: ${colors.nightDark};
        `}
    }

    ${({ disabled }) => disabled && `
        cursor: not-allowed;
        pointer-events: none;
        opacity: 0.5;
    `}

    ${({ active }) => active && `
        background: ${panelAccentAlpha(colors.secondaryPurple, '14')};
        color: ${panelAccent(colors.secondaryPurple)};
        font-weight: 600;
    `}
`;
